import { AuthFetchWithResponse } from 'src/Types/api'
import { StatusCodes } from 'src/Libs/http-status-codes'
import { ApiResult } from 'src/Libs/api'
import { AuthFetchError } from '@e3dc-react/shell/Types/api'
import { handleFetchError } from 'src/Libs/api/utils'

/**
 * fetch vehicle image of type blob (binary large object)
 */
export const fetchVehicleImage = async (
  installationId: string | undefined,
  vehicleId: string | undefined,
  authFetch: AuthFetchWithResponse
): Promise<ApiResult<Blob, AuthFetchError | Error>> => {
  if (!installationId || !vehicleId) {
    return new ApiResult<Blob, AuthFetchError | Error>(null, true, new Error('Installation ID or Vehicle ID is undefined'))
  }
  try {
    const response = await authFetch<Blob>({
      path: `vehicles/installations/${installationId}/vehicles/${vehicleId}/image`,
      method: 'GET',
      endpoint: process.env.REACT_APP_VEHICLES_ENDPOINT,
      type: 'blob',
    })

    if (response.status === StatusCodes.OK) {
      return new ApiResult<Blob, AuthFetchError | Error>(response.data, false)
    }

    return new ApiResult<Blob, AuthFetchError | Error>(null, true)
  } catch (error) {
    return handleFetchError<Blob>(error)
  }
}
